import { jsonGet, jsonPost } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import { makeDatepickerAccessible } from '../utilities/helper';

let selectedDate;
const errorMsgTextboxCls = 'error-msg-textbox';
const modifyOrderProductRowCls = '.modify-order-product-row';
const modifyOrderPriceCls = '.modify-order-total-price_value';
const modifyOrderSupplyPeriodOptions = '.modify-order-supplyperiod-options';
const modifyOrderSupplyPeriodUnitCls = '.js-modify-quantandnum-dropdown';
const modifyOrderSupplyPeriodDurationCls = '.js-modify-weekandmonth-dropdown';
const modifyOrderQtyCls = '.js-modify-quantity-dropdown';
const modifyOrderForm = '#orderEntryActionForm';

const modifyOrderFunction = {
  datepickerValue: {
    onSelect(date) {
      const $this = $(this);
      $this.val(date);
      modifyOrderFunction.chkErrorMsg($this);
      const $dobCls = $('.modify-order-birth-date-input');
      const firstDobIdVal = $dobCls
        .first()
        .attr('id')
        .split('_')[1];
      const currentDobId = $this.attr('id');
      const currentDobIdVal = currentDobId.split('_')[1];
      if (currentDobIdVal === firstDobIdVal) {
        selectedDate = date;
        modifyOrderFunction.infantDobAjax();
      }
    },
    minDate: '-365d',
    maxDate: '+365d',
    beforeShow() {
      makeDatepickerAccessible($(this));
    },
    onClose() {
      $(this)
        .parents('.modify-order-product-row')
        .find('.modify-order-remove-item a')
        .focus();
    }
  },
  infantDobAjax() {
    const infantDob = selectedDate;
    if(!isNaN(Date.parse(infantDob))){
      const url = `${ACC.config.encodedContextPath}${API_REFERENCE.modifyOrder.saveInfantDob}`;
      const payload = { infantBirthDate: infantDob };
      jsonGet(url, payload).then(response => {});
    }
  },
  chkErrorMsg($this) {
    if ($this.val() === '') {
      $this
        .parent()
        .next()
        .show();
      $this.addClass(errorMsgTextboxCls);
    } else {
      $this
        .parent()
        .next()
        .hide();
      $this.removeClass(errorMsgTextboxCls);
    }
  },
  modifySupplyDetailsAjax(param, $current) {
    const requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.cart.saveSupplyDetails}`;
    const submitdata = JSON.stringify(param);
    jsonPost(requestURL, submitdata).then(response => {
      const updatedPrice = response.estimatedTotalPrice;
      if (updatedPrice !== null) {
        const updatedPriceVal = response.estimatedTotalPrice.formattedValue;
        $current.find(modifyOrderPriceCls).text(updatedPriceVal);
      }
    });
  },
  modifyQuantity() {
    const $that = $(this);
    const $currentParentRow = $that.parents(modifyOrderProductRowCls);
    const $supplyPeriodParent = $currentParentRow.find(
      modifyOrderSupplyPeriodOptions
    );
    let supplyPeriodUnitVal = '';
    let supplyPeriodDurationVal = '';
    if ($supplyPeriodParent.length > 0) {
      supplyPeriodUnitVal = $supplyPeriodParent
        .find(modifyOrderSupplyPeriodUnitCls)
        .val()
        .toString();
      supplyPeriodDurationVal = $supplyPeriodParent
        .find(modifyOrderSupplyPeriodDurationCls)
        .val()
        .slice(0, 1);
    }
    const objParam = {
      entryNumber: $currentParentRow.data('entry'),
      productCode: $currentParentRow.data('product-code').toString(),
      supplyPeriodUnit: supplyPeriodUnitVal,
      supplyPeriodDuration: supplyPeriodDurationVal,
      quantity: $that.val(),
      selectedItem: 'quantity'
    };
    modifyOrderFunction.modifySupplyDetailsAjax(objParam, $currentParentRow);
  },
  modifySupplyPeriodDuration() {
    let supplyTotalDuration;
    let supplyDropdown = '<option class="hidden"></option>';
    const $supplyPeriodParent = $(this).parents(modifyOrderSupplyPeriodOptions);
    const $durationSupplyPeriod = $supplyPeriodParent.find(
      modifyOrderSupplyPeriodUnitCls
    );
    $durationSupplyPeriod.empty();
    const duration = $(this).val();
    supplyTotalDuration = $(this).data('modify-supply-unit');
    const maxSupplyPeriodDuration = $(this).data('modify-supply-duration');
    if (duration === 'Months' && maxSupplyPeriodDuration === 'Weeks') {
      supplyTotalDuration = parseInt(supplyTotalDuration / 4, 0);
    } else if (duration === 'Weeks' && maxSupplyPeriodDuration === 'Months') {
      supplyTotalDuration *= 4;
    }
    for (let i = 1; i <= supplyTotalDuration; i += 1) {
      supplyDropdown += `<option value='${i}'> ${i} </option>`;
    }
    $durationSupplyPeriod.html(supplyDropdown);
    $durationSupplyPeriod.selectmenu('refresh');
  },

  modifySupplyPeriodValue() {
    const $that = $(this);
    const $currentParentRow = $that.parents(modifyOrderProductRowCls);
    const $supplyPeriodParent = $that.parents(modifyOrderSupplyPeriodOptions);
    const objParam = {
      entryNumber: $currentParentRow.data('entry'),
      productCode: $currentParentRow.data('product-code').toString(),
      supplyPeriodUnit: $that.val(),
      supplyPeriodDuration: $supplyPeriodParent
        .find(modifyOrderSupplyPeriodDurationCls)
        .val()
        .slice(0, 1),
      quantity: $currentParentRow.find(modifyOrderQtyCls).val(),
      selectedItem: 'supplyPeriod'
    };
    modifyOrderFunction.modifySupplyDetailsAjax(objParam, $currentParentRow);
  },

  openModifyOrder(e) {
    e.preventDefault();
    const modifyOrderCode = $(this).attr('data-modify-order-code');
    window.location.href = `${ACC.config.encodedContextPath}${API_REFERENCE.modifyOrder.navigateToModifyOrder}${modifyOrderCode}`;
    return false;
  },
  openConfirmOrder(e) {
    e.preventDefault();
    const orderCode = $(this).attr('data-modify-order-code');
    window.location.href = `${ACC.config.encodedContextPath}${API_REFERENCE.modifyOrder.navigateToConfirmOrder}${orderCode}`;
    return false;
  },
  validateModifyRequiredFields() {
    let textEntered = true;
    if ($('.modify-order-section input[type=text]:required').length > 0) {
      $('.modify-order-section input[type=text]:required').each(function() {
        if ($(this).val() === '') {
          textEntered = false;
          $(this)
            .parent()
            .next()
            .show();
          $(this).addClass(errorMsgTextboxCls);
        } else {
          $(this)
            .parent()
            .next()
            .hide();
          $(this).removeClass(errorMsgTextboxCls);
        }
      });
    }
    if (textEntered === true) {
      $(modifyOrderForm).submit();
    }
  },
  displayGlobalMessage() {
    let $accConfMsg = $('.page-modifyOrder .global-alerts .alert-info');
    if ($accConfMsg.length) {
      let alertMessage = $accConfMsg
        .text()
        .trim()
        .substring(1);
      let $genericErrorContainer = $('.modify-order-section')
        .parent()
        .find('.removal-notification-msg');
      $accConfMsg.addClass('hidden');
      $genericErrorContainer
        .removeClass('hidden')
        .find('.removal-notification-text')
        .text(alertMessage);
    }
  },
  showAlert() {
    let $ariaSpan = $('.modify-order-remove-aria-label');
    setTimeout(function() {
      $ariaSpan.removeClass('hidden').addClass('sr-only');
    }, 700);
  },
  hideAlert() {
    let $ariaSpan = $('.modify-order-remove-aria-label');
    $ariaSpan.removeClass('sr-only').addClass('hidden');
  },
  alertOnLastRecord() {
    let $removeLink = $('.modify-order-remove_link');
    if ($removeLink.length === 1) {
      $removeLink.focus(function() {
        modifyOrderFunction.showAlert();
      });
      $removeLink.on('focusout', modifyOrderFunction.hideAlert);
    }
    $removeLink.on('keydown', function(event) {
      if (event.keyCode === 17) {
        modifyOrderFunction.hideAlert();
      }
    });
  },
  init() {
    modifyOrderFunction.alertOnLastRecord();
    modifyOrderFunction.displayGlobalMessage();
    if ($('.order-history-management-template').length > 0) {
      if ($('.search-results-count .pagination__wrapper').length === 0) {
        $('.orderHistory_paginationRow').addClass(
          'orderHistory_paginationRow_space'
        );
      }
    }
    $('.modify-order-birth-date-input').datepicker(this.datepickerValue);
    $(document).on(
      'click',
      '.modify-order-product-row .ui-selectmenu-button',
      ACC.utility.setDropdownHeight
    );
    $(document).on('selectmenuchange', modifyOrderQtyCls, this.modifyQuantity);
    $(document).on(
      'selectmenuchange',
      modifyOrderSupplyPeriodDurationCls,
      this.modifySupplyPeriodDuration
    );
    $(document).on(
      'selectmenuchange',
      modifyOrderSupplyPeriodUnitCls,
      this.modifySupplyPeriodValue
    );
    $(document).on('click', '.orderModifyButton', this.openModifyOrder);
    $(document).on('click', '.confirmOrderButton', this.openConfirmOrder);
    $(document).on(
      'click',
      '.modify-order-confirm-button',
      this.validateModifyRequiredFields
    );
    $(document).on('click', '.modify-order-birth-date_calender',checkManualDateValidity, function() {
      $(this)
        .prev()
        .focus();
    });
  }
};
modifyOrderFunction.init();
export default modifyOrderFunction;

function checkManualDateValidity() {
    let $errorMsg = $('.error-msg-text-date');
    let $errorMesgRange = $('.error-msg-text-date-range');
    if (!$(this).val().length) {
        $errorMsg.hide();
        return false;
    }
    let dateValid = validateDateManualEntry($(this).val());
    if (!dateValid) {
        $errorMsg.show();
    } else {
        $errorMsg.hide();
    }
    let dateValidRange = validateDateRange($(this).val());
    if (!dateValidRange) {
        $errorMesgRange.show();
    } else {
        $errorMesgRange.hide();
    }
}

function validateDateRange(dateEntered) {
    var date1 = new Date(dateEntered);
    var date = new Date();
    var difference_In_Time = date.getTime() - date1.getTime();
    var difference_In_Days = Math.floor(difference_In_Time / (1000 * 3600 * 24));
    if (difference_In_Days <= 365 && difference_In_Days >= -365) {
        return true;
    } else {
        return false;
    }
}
